// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-physical-price[data-v-406b89de]{align-items:flex-start;display:flex;flex-direction:column;padding:var(--spacing-lg-2) var(--spacing-md-3) 0}@media(min-width:1024px){.product-physical-price[data-v-406b89de]{padding:var(--spacing-lg-2) var(--spacing-lg-2) 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
